var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0-7.733-6.267-14-14-14S0 6.267 0 14c0 6.99 5.119 12.78 11.813 13.83v-9.783H8.258V14h3.555v-3.084c0-3.509 2.089-5.447 5.288-5.447 1.531 0 3.133.273 3.133.273v3.446h-1.766c-1.74 0-2.28 1.08-2.28 2.187V14h3.882l-.62 4.047h-3.262v9.784C22.88 26.78 28 20.989 28 14z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 18.047L20.07 14h-3.883v-2.625c0-1.107.542-2.188 2.281-2.188h1.766V5.742s-1.602-.273-3.133-.273c-3.2 0-5.288 1.938-5.288 5.447V14H8.258v4.047h3.555v9.784c.713.112 1.443.169 2.187.169.744 0 1.474-.057 2.188-.17v-9.783h3.262z",
    fill: "#fff"
  })));
}

export default SvgFacebook;